import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheOpulentGlowExperience() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section data-section-id="1694" id="the-art-of-radiance" className="relative min-h-screen w-full overflow-hidden bg-background flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/marble_silk_background.png" className="h-full w-full object-cover opacity-60 blur-[1px]">
          <source src="/video/marble-silk-bg.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-primary/20 backdrop-blur-[2px]" />
      </div>

      <div className="container relative z-10 mx-auto px-6 py-8 md:py-32 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-2 lg:items-center lg:gap-20">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="text-sm font-medium tracking-[0.2em] uppercase text-foreground/60">Luxury Beauty & Aesthetic Treatments Norwich</h1>
            <h1 className="font-serif text-4xl font-light leading-[1.1] tracking-wider text-foreground drop-shadow-sm md:text-7xl lg:text-8xl">
              Your Glow <br />
              <span className="italic text-foreground/80">Starts Here</span>
            </h1>
            
            <p className="max-w-lg font-sans text-lg font-light leading-relaxed text-foreground/70 md:text-xl">Step into a calm and welcoming space in Brooke, where beauty meets relaxation. At Natalia’s Beauty, we combine expert treatments with a personal touch — from beauty and aesthetics to soothing massage — all designed to help you look and feel your best.</p>

            <div className="pt-4">
              <Button asChild size="lg" className="h-14 rounded-lg bg-secondary px-10 text-sm tracking-widest uppercase font-medium text-secondary-foreground shadow-md transition-all hover:scale-105 hover:bg-accent hover:shadow-lg">
                <Link to="tel:07766733976">
                  Begin Your Journey
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-full md:max-w-md lg:max-w-full transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="relative aspect-[3/4] w-full rotate-0 border-[12px] border-background bg-background shadow-xl md:aspect-[4/5] md:rotate-2 lg:rotate-3">
              <div className="absolute -inset-4 -z-10 rotate-0 border border-border bg-secondary/30 md:rotate-[-6deg]" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/facial_treatment_luxury_experience.png" alt="High-end aesthetics and beauty therapy at Natalia's Beauty" className="h-full w-full object-cover" />
              
              <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent opacity-40 pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}